function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';

/**
 * This and the CSSProp type is copied from styled-components V6.  This allows us to support both V5 and V6.
 *
 * This is because `null` was built into this type in V6 but we had added it to our style prop in V5 here.
 * So when we built our library with V6 TS would simplify the type and remove the `null` from the style prop because it
 * was part of this type in V6.  However when used with V5 it would not have `null` in the type and would error.
 *
 * This could be removed and use the type from styled-components directly when we remove support for V5 in a breaking change.
 */

/**
 * The `css` prop is not declared by default in the types as it would cause `css` to be present
 * on the types of anything that uses styled-components indirectly, even if they do not use the
 * babel plugin.
 *
 * To enable support for the `css` prop in TypeScript, create a `styled-components.d.ts` file in
 * your project source with the following contents:
 *
 * ```ts
 * import type { CSSProp } from "styled-components";
 *
 * declare module "react" {
 *  interface Attributes {
 *    css?: CSSProp;
 *  }
 * }
 * ```
 *
 * In order to get accurate typings for `props.theme` in `css` interpolations, see
 * {@link DefaultTheme}.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export const asPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]);
export const stylePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]);

/**
 * Type used for render props
 *
 * ```typescript
 * type MyComponentProps = StylableComponent<HTMLDivElement> & {
 * renderBody?: (props: StylableRenderPropType) => ReactElement;
 * }
 * ```
 */

const isNotEmpty = value => !!value && value.trim().length > 0;
const parseStyleString = styleString => styleString.split(';').filter(isNotEmpty).map(cur => cur.split(':')).reduce((acc, val) => {
  const [key, value] = val;
  const camelCaseKey = key.trim().replace(/-./g, css => css.toUpperCase()[1]);
  acc[camelCaseKey] = value.trim();
  return acc;
}, {});

/**
 * Converts styled-components type of style (array or object) to one compatible with react.
 * This is useful for converting our style before providing it to users through render functions.
 * If a user of ours does not use styled-components it can be difficult for them to apply it
 * without us converting it first.
 *
 * @param style styled-components specific style
 * @returns Regular react-style style object
 */
export const flattenStyle = style => {
  if (!style) {
    return undefined;
  }
  if (typeof style === 'string') {
    return parseStyleString(style);
  }
  if (!Array.isArray(style)) {
    return style;
  }
  return style.map(x => flattenStyle(x)).reduce((acc, curr) => {
    return _objectSpread(_objectSpread({}, acc), curr);
  }, {});
};
//# sourceMappingURL=styledComponents.js.map